export default {
  base: {
    variant: 'spark.base.wrapper',
    borderCollapse: 'collapse',
    minWidth: ['100%', 'initial'],
    px: '8px',
    py: '16px',
    textAlign: 'left',
    '&:first-of-type': {
      paddingLeft: '16px'
    },
    '&:last-child': {
      paddingRight: '16px'
    }
  },
  th: {
    base: {
      variant: 'spark.element.table.base',
      minWidth: '30px',
      backgroundColor: 'grey-05',
      '&& + td': {
        paddingLeft: '8px'
      }
    }
  },
  tr: {
    base: {
      '&:nth-of-type(even)': {
        backgroundColor: 'grey-0'
      },
      '&:nth-of-type(odd)': {
        backgroundColor: 'grey-0'
      }
    },
    variants: {
      borderBottom: {
        variant: 'spark.element.table.tr.base',
        borderBottom: '1px solid',
        borderColor: 'grey-20'
      },
      striped: {
        variant: 'spark.element.table.tr.base',
        '&:nth-of-type(even)': {
          backgroundColor: 'grey-0'
        },
        '&:nth-of-type(odd)': {
          backgroundColor: 'grey-05'
        }
      },
      borderBottomStriped: {
        variant: 'spark.element.table.tr.base',
        borderBottom: '1px solid',
        borderColor: 'grey-20',
        '&:nth-of-type(even)': {
          backgroundColor: 'grey-0'
        },
        '&:nth-of-type(odd)': {
          backgroundColor: 'grey-05'
        }
      }
    }
  },
  td: {
    base: {
      variant: 'spark.element.table.base',
      fontSize: 'xs',
      fontWeight: 'semiBold',
      minWidth: '30px',
      '&& + th': {
        paddingLeft: '8px'
      }
    }
  }
};